import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="#999"
      d="m7.938 9.875-1.25-1.23a.72.72 0 0 0-.521-.228.72.72 0 0 0-.521.229.73.73 0 0 0 0 1.062l1.77 1.771q.23.23.521.23a.72.72 0 0 0 .521-.23l3.896-3.896a.73.73 0 0 0 0-1.062.72.72 0 0 0-.52-.23.72.72 0 0 0-.521.23zm-2.042 7.063-1.23-2.021-2.291-.521a.75.75 0 0 1-.458-.281.66.66 0 0 1-.125-.51L2 11.25.438 9.5A.77.77 0 0 1 .25 9q0-.27.188-.5L2 6.75l-.208-2.354a.66.66 0 0 1 .125-.51.75.75 0 0 1 .458-.282l2.292-.52 1.229-2.021A.78.78 0 0 1 6.302.74a.74.74 0 0 1 .531.01L9 1.688 11.167.75a.74.74 0 0 1 .53-.01q.262.093.407.323l1.23 2.02 2.291.521a.75.75 0 0 1 .458.281.66.66 0 0 1 .125.51L16 6.75l1.563 1.75q.187.23.187.5t-.187.5L16 11.25l.208 2.354a.66.66 0 0 1-.125.51.75.75 0 0 1-.458.282l-2.292.52-1.229 2.021a.78.78 0 0 1-.406.323.74.74 0 0 1-.531-.01L9 16.313l-2.167.937a.74.74 0 0 1-.53.01.78.78 0 0 1-.407-.323m.937-1.334L9 14.688l2.167.916 1.208-2.02 2.292-.521-.209-2.313L16 9l-1.542-1.75.209-2.312-2.292-.521-1.208-2.021L9 3.313l-2.167-.917-1.208 2.02-2.292.5.209 2.334L2 9l1.563 1.75-.23 2.333 2.292.521z"
    />
  </svg>
);
export default SvgVerified;
